import Image from 'next/legacy/image'

type BrandLogoProps = {
  width: number
  height: number
  className?: string
  src?: string
  alt?: string
}

const BrandLogo: React.FC<BrandLogoProps> = ({
  width,
  height,
  className = '',
  src = '/images/Sunbeam.svg',
  alt = 'Thriveworks Logo',
}) => {
  return (
    <Image
      unoptimized
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
    />
  )
}

export default BrandLogo
